/**
 * @author Bhavani Naralasetty
 * @email Bhavani.Naralaseetty@ul.com
 * @create date 2019-08-09 15:07:41
 * @modify date 2019-08-09 15:07:41
 * @desc [description]
 */
import axios from 'axios';

/**
 * getChartsDataOverView get API
* to get the summary details */
export async function getChartsDataOverView() {
  let summaryData = {};
  await axios.get(`${process.env.VUE_APP_JAVA_API_URL}/Charts_Data_Overview`).then((response) => {
    summaryData = response.data.data;
  }).catch((err) => {
    console.log('get charts_data_overview python api error', err); // eslint-disable-line no-console
  });
  return summaryData;
}

/**
 * getCharts get API
* to get the chart details for report country */
export async function getCharts() {
  let chartsData = {};
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/getChartsDataGetResponse`)
    .then((response) => {
      chartsData = response.data.data;
      console.log('charts data', chartsData);
    }).catch((err) => {
      console.log('get charts java api error', err); // eslint-disable-line no-console
    });
  return chartsData;
}
